import {
  SELECT_CHANGEVALUE,
  PO_LIST,
  PO_LIST_SUCCESS,
  ADD_PO_DATA,
  INPUT_CHANGEVALUE,
  IGP_INPUT_CHANGEVALUE,
  IGP_ITEM_SELECT,
  IGP_ADD,
  IGP_LIST,
  IGP_LIST_SUCCESS,
  TOGGLE_ITEM_MENU,
  SET_PARAMS,
  FILTER_INPUT_CHANGEVALUE,
  FILTER_SELECT_CHANGEVALUE,
  IGP_ROW_DATA,
  IGP_ROW_DATA_SUCCESS,
  LIST_LAYOUT,
  PO_ITEM_LIST,
  PO_ITEM_LIST_SUCCESS,
  FILTERS_SHOW_RIGHT_SIDEBAR,
  FILTERS_HIDE_RIGHT_SIDEBAR,
  CLEAR_FILTER,
  ITEM_QTY_CHANGEVALUE,
  ITEM_UNITES_CHANGEVALUE,
  PO_ITEM_MODEL_CLOSE,
  IGP_ADD_PO_DATA,
  IGP_PO_DATA_REMOVE,
  PREVIEW_IMAGE,
  UPLOAD_IGP_IMAGE,
  UPLOAD_IGP_IMAGE_SUCCESS,
  UPLOAD_IMAGE,
} from "./actionTypes";
import Swal from "sweetalert2";

const initialState = {
  IGPRowData: {},
  poList: [],
  loading: false,
  PORowData: {},
  igpitems: [],
  IGPRowList: [],
  IGPRowListCount: 0,
  IGPitems: [],
  IGPPOs: [],
  Sortvar: {
    code: "IGP NO",
    createdon: "CREATED ON",
  },
  params: {
    no_of_pages: 0,
    page_size: 10,
    page: 1,
    search: "",
    currentSort: "code",
    sortOrder: "-",
  },
  layout: "list",
  poData: {},
  poItemsList: [],
  filterPOData: [],
  IGPcheckedItem: [],
  itemSelectedId: null,
  showFilterRightSidebar: false,
  poItemsModel: false,
  IGPPOData: [],
  previewImage: null,
  personImage: {},
  vehicleImage: {},
};

const ingatepass = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_CHANGEVALUE:
      state = {
        ...state,
        PORowData: {},
        IGPRowData: {
          ...state.IGPRowData,
          [action.payload.key]: action.payload.label,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case PO_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case PO_LIST_SUCCESS:
      var IGPPOIds = state.IGPPOData.map((po) => {
        return po.purchaseorder_id;
      });
      var poListData = action.payload.results.filter((po) => {
        return IGPPOIds.indexOf(po.id) === -1;
      });
      state = {
        ...state,
        poList: poListData,
        loading: false,
      };
      break;

    case ADD_PO_DATA:
      var POIds = state.igpitems.map((item) => item.purchaseorder_id);
      if (POIds.indexOf(action.payload.Podata.id) === -1) {
        state = {
          ...state,
          igpitems: [
            ...state.igpitems,

            {
              purchaseorder: {
                code: action.payload.Podata.code,
                id: action.payload.Podata.id,
                items_count: action.payload.Podata.items_count,
                vendor: {
                  name: action.payload.Podata.vendor.name,
                },
                requestforquotation_code:
                  action.payload.Podata.requestforquotation_code,
              },
            },
          ],
        };
      } else {
        Swal.fire({
          icon: "error",
          text: "PO Number already added in the list",
        });
      }
      break;
    case INPUT_CHANGEVALUE:
      state = {
        ...state,
        PORowData: {
          ...state.PORowData,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case IGP_INPUT_CHANGEVALUE:
      state = {
        ...state,
        IGPRowData: {
          ...state.IGPRowData,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case IGP_ITEM_SELECT:
      if (action.payload.checked === true) {
        state.filterPOData[action.payload.index].itemcheck = true;
        state = {
          ...state,
          IGPcheckedItem: [...state.IGPcheckedItem, { ...action.payload.item }],

          loading: false,
        };
      } else {
        state.filterPOData[action.payload.index].itemcheck = false;
        var igpcheckedItem = state.IGPcheckedItem.filter((p) => {
          return p.id !== action.payload.item.id;
        });

        state = {
          ...state,

          IGPcheckedItem: igpcheckedItem,
        };
      }

      break;

    case IGP_ADD:
      state = {
        ...state,
        loading: true,
      };
      break;
    case IGP_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case IGP_LIST_SUCCESS:
      var noofpages = Math.ceil(action.payload.count / state.params.page_size);
      state = {
        ...state,
        IGPRowList: action.payload.results,
        IGPRowListCount: action.payload.count,
        params: {
          ...state.params,
          no_of_pages: noofpages,
        },
        loading: false,
      };
      break;
    case TOGGLE_ITEM_MENU:
      var IGPRowList = state.IGPRowList?.map((i) => {
        if (i.id === action.payload) {
          i.actionMenu = !i.actionMenu;
        } else {
          i.actionMenu = false;
        }
        return i;
      });

      state = {
        ...state,
        IGPRowList: IGPRowList,
      };
      break;
    case SET_PARAMS:
      state = {
        ...state,
        params: action.payload,
      };
      break;
    case FILTER_INPUT_CHANGEVALUE:
      state = {
        ...state,
        params: {
          ...state.params,
          [action.payload.key]: action.payload.value,
        },
      };
      break;
    case FILTER_SELECT_CHANGEVALUE:
      state = {
        ...state,
        filterdata: {
          ...state.filterdata,
          [action.payload.key]: action.payload.label,
        },
        params: {
          ...state.params,
          [action.payload.key2]: action.payload.value,
        },
      };
      break;
    case IGP_ROW_DATA:
      state = {
        ...state,
        loading: true,
      };
      break;
    case IGP_ROW_DATA_SUCCESS:
      state = {
        ...state,
        IGPRowData: action.payload,
        IGPitems: action.payload.grn2items,
        IGPPOs: action.payload.grn2pos,
        loading: false,
      };
      break;
    case LIST_LAYOUT:
      state = {
        ...state,
        layout: action.payload,
        loading: false,
      };
      break;
    case PO_ITEM_LIST:
      state = {
        ...state,
        loading: false,
        itemSelectedId: action.payload.PoID,
        IGPcheckedItem: [],
      };
      break;
    case PO_ITEM_LIST_SUCCESS:
      var poItems = [];
      var filterpoData = [];
      var description = "";
      var bill_image = "";

      if (state.IGPPOData.length !== 0) {
        var inputPolist = state.IGPPOData.filter((podata) => {
          return podata.purchaseorder_id === state.itemSelectedId;
        });
        if (inputPolist.length > 0) {
          var poData = inputPolist[0];
          description = poData.description;
          bill_image = poData.bill_image;
          poItems = action.payload.poitems.map((p) => {
            p.purchaseorder_id = action.payload.id;
            var itemL = poData.grn2items.filter((podata) => {
              return podata.id === p.id;
            });
            if (itemL.length > 0) {
              var item = itemL[0];
              // p.availableqty = podata.grn2items.qty;
              p.itemcheck = true;
              p.t_qty = item.t_qty;
              p.t_unit = item.t_unit;
            } else {
              p.itemcheck = false;
              p.t_qty = p.availableqty;
              p.t_unit = p.unit;
            }
            return p;
          });
        } else {
          poItems = action.payload.poitems.map((p) => {
            p.itemcheck = false;
            p.purchaseorder_id = action.payload.id;
            p.t_qty = p.availableqty;
            p.t_unit = p.unit;
            return p;
          });
          filterpoData = poItems.filter((item) => item.availableqty > 0);
        }

        filterpoData = poItems.filter((item) => item.availableqty > 0);
      } else {
        poItems = action.payload.poitems.map((p) => {
          p.itemcheck = false;
          p.t_qty = p.availableqty;
          p.t_unit = p.unit;
          p.purchaseorder_id = action.payload.id;
          return p;
        });
        filterpoData = poItems.filter((item) => item.availableqty > 0);
      }
      // var filterpoData = poItems.filter((item) => item.availableqty > 0);
      var IGPcheckedItem = poItems.filter((item) => item.itemcheck);
      state = {
        ...state,
        poData: action.payload,
        poItemsList: poItems,
        filterPOData: filterpoData,
        loading: false,
        poItemsModel: true,
        IGPcheckedItem: IGPcheckedItem,
        PORowData: { ...state.PORowData, description, bill_image },
      };
      break;
    case FILTERS_SHOW_RIGHT_SIDEBAR:
      state = {
        ...state,
        showFilterRightSidebar: !state.showFilterRightSidebar,
      };
      break;
    case FILTERS_HIDE_RIGHT_SIDEBAR:
      state = {
        ...state,

        showFilterRightSidebar: false,
      };
      break;
    case CLEAR_FILTER:
      state = {
        ...state,
        filterdata: {},
      };
      break;
    case ITEM_QTY_CHANGEVALUE:
      var QtyChangeItem = [];

      QtyChangeItem = state.IGPcheckedItem.map((p) => {
        if (p.product?.id === action.payload.item.product.id) {
          p.t_qty = action.payload.value;
        }
        return p;
      });
      state = {
        ...state,
        IGPcheckedItem: QtyChangeItem,
      };

      break;
    case ITEM_UNITES_CHANGEVALUE:
      var UniteChangeItems = [];

      UniteChangeItems = state.IGPcheckedItem.map((p) => {
        if (p.product?.id === action.payload.item.product.id) {
          p.t_unit = {
            id: action.payload.value,
            name: action.payload.label,
          };
        }
        return p;
      });

      state = {
        ...state,
        IGPcheckedItem: UniteChangeItems,
      };

      break;
    case PO_ITEM_MODEL_CLOSE:
      state = {
        ...state,
        poItemsModel: false,
        PORowData: {},
      };

      break;
    case IGP_ADD_PO_DATA:
      var nl = state.IGPPOData.filter((p) => {
        return !(p.purchaseorder_id === action.payload.purchaseorder_id);
      });
      nl.push(action.payload);

      state = {
        ...state,
        IGPPOData: nl,
        poItemsModel: false,
        PORowData: {},
      };
      break;
    case PREVIEW_IMAGE:
      state = {
        ...state,
        loading: false,
        previewImage: action.payload.imageFile,
      };
      break;
    case UPLOAD_IMAGE:
      state = {
        ...state,
        loading: false,
        // POBillImg: action.payload.poBillImg,
      };
      break;
    case UPLOAD_IGP_IMAGE:
      state = {
        ...state,
        loading: true,
        // POBillImg: action.payload.poBillImg,
      };
      break;
    case UPLOAD_IGP_IMAGE_SUCCESS:
      if (action.payload.ImageType === "vehicle") {
        state = {
          ...state,
          vehicleImage: action.payload.ImageData,
          loading: false,
        };
      } else if (action.payload.ImageType === "person") {
        state = {
          ...state,
          personImage: action.payload.ImageData,
          loading: false,
        };
      }
      state = {
        ...state,
        loading: false,
      };
      break;
    case IGP_PO_DATA_REMOVE:
      var filterdata = state.IGPPOData.filter((podata) => {
        return !(action.payload.purchaseorder_id === podata.purchaseorder_id);
      });
      state = {
        ...state,
        IGPPOData: filterdata,
        itemSelectedId: null,
        // poItemsModel: false,
        // PORowData: {},
      };
      break;
    default:
      state = { ...state };
      break;
    //-------------------
  }

  return state;
};
export default ingatepass;
